import Cart from "../pages/User/Cart/Cart";
import Home from "../pages/User/Home/Home";
import Lotteries from "../pages/User/Lotteries/Lotteries";
import AboutUs from "../pages/User/AboutUs/AboutUs";
import ContactUs from "../pages/User/ContactUs/ContactUs";
import MyTickets from "../pages/User/MyTickets/MyTickets";
import Profile from "../pages/User/Profile";
import ProtectedRoute from "./PrivateRoute";
import Winners from "../pages/User/Winners/Winners";
import MySubscriptions from "../pages/User/MySubscriptions/MySubscriptions";
import Results from "../pages/User/Results/Results";
import TermsAndConditions from "../pages/User/TermsandConditions/TermsAndConditions";
import PaymentPolicy from "../pages/User/PaymentPolicy/PaymentPolicy";
import Wallet from "../pages/User/Wallet/Wallet";
import WebXPaySubscription from "../pages/User/WebXPaySubscription/WebXPaySubscription";

var UserRoutes = [
  {
    path: "/",
    name: "Home",
    element: <Home />,
  },
  {
    path: "/lotteries",
    name: "Lotteries",
    element: <Lotteries />,
  },
  {
    path: "/cart",
    name: "Cart",
    element: (
      <ProtectedRoute allowedRoles={["customer"]}>
        <Cart />
      </ProtectedRoute>
    ),
  },
  {
    path: "/my-tickets",
    name: "My Tickets",
    element: (
      <ProtectedRoute allowedRoles={["customer"]}>
        <MyTickets />
      </ProtectedRoute>
    ),
  },
  {
    path: "/my-profile",
    name: "My Profile",
    element: (
      <ProtectedRoute allowedRoles={["customer"]}>
        <Profile />
      </ProtectedRoute>
    ),
  },
  {
    path: "/about",
    name: "About Us",
    element: <AboutUs />,
  },
  {
    path: "/contact",
    name: "Contact Us",
    element: <ContactUs />,
  },
  {
    path: "/winners",
    name: "Winners",
    element: <Winners />,
  },
  {
    path: "/subscriptions",
    name: "Subscriptions",
    element: (
      <ProtectedRoute allowedRoles={["customer"]}>
        <MySubscriptions />
      </ProtectedRoute>
    ),
  },
  {
    path: "/results",
    name: "Results",
    element: <Results />,
  },
  {
    path: "/terms-and-conditions",
    name: "Terms and Conditions",
    element: <TermsAndConditions />,
  },
  {
    path: "/privacy-policy",
    name: "Privacy Policy",
    element: <PaymentPolicy />,
  },
  {
    path: "/wallet",
    name: "Wallet",
    element: (
      <ProtectedRoute allowedRoles={["customer"]}>
        <Wallet />
      </ProtectedRoute>
    ),
  },
  {
    path: "/subscription/:id",
    name: "Subscription",
    element: (
      <ProtectedRoute allowedRoles={["customer"]}>
        <WebXPaySubscription />
      </ProtectedRoute>
    ),
  },
];
export default UserRoutes;
